import React, { useState, useEffect, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import Footer from "./components/menu/footer";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { FaSpinner } from "react-icons/fa";
import { AuthContext } from "./context/AuthProvider";

const Login = () => {
  const navigate = useNavigate();
  const { login, user } = useContext(AuthContext);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) {
      navigate("/home");
    }
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage(null);
    setLoading(true);

    if (!email.trim() || !password.trim()) {
      setErrorMessage("Por favor, complete todos los campos");
      return;
    }

    try {
      await login(email.trim(), password.trim());
    } catch (error) {
      setErrorMessage(error.message || "Error al iniciar sesión");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col mx-4 justify-center ">

      <div className="flex justify-center items-center min-h-screen ">
        <div className="border border-white p-8 rounded-lg shadow-sm shadow-white w-full sm:w-96 md:w-1/3">
          <Link to="/" className="flex  justify-center mb-6">
            <img
              src="/isologo.png"
              className="object-contain w-[150px] sm:w-[200px] lg:w-[280px]"
              alt="NETMAX Logo"
            />
          </Link>
          <h2 className="text-2xl text-white font-semibold text-center mb-4">
            Iniciar sesión
          </h2>
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label htmlFor="username" className="block text-gray-100">
                Usuario
              </label>
              <input
                type="text"
                id="username"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full p-3 h-10 mt-1 border border-gray-300 rounded-lg focus:outline-none focus:border-purple-800 text-black"
                placeholder="Ingrese su usuario"
              />
            </div>
            <div className="mb-6 relative">
              <label htmlFor="password" className="block text-gray-100">
                Contraseña
              </label>
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full p-3 h-10 mt-1 border border-gray-300 rounded-lg focus:outline-none focus:border-purple-800 text-black pr-10"
                placeholder="Ingrese su contraseña"
              />
              <button
                type="button"
                onClick={() => setShowPassword((prev) => !prev)}
                className="absolute right-3 top-[42px] transform -translate-y-1/2 text-gray-600 focus:outline-none"
              >
                {showPassword ? (
                  <FaEyeSlash className="w-5 h-5" />
                ) : (
                  <FaEye className="w-5 h-5" />
                )}
              </button>
            </div>

            {errorMessage && (
              <div className="w-full text-red-500 text-center text-sm my-2">
                <p>{errorMessage}</p>
              </div>
            )}
            <div className="flex gap-2">
              <Link
                to="/play"
                className="w-full py-2 text-center border bg-white text-purple-900 rounded-lg hover:opacity-70 focus:outline-none"
              >
                Cancelar
              </Link>

              <button
                type="submit"
                disabled={loading}
                className={`w-full py-2 bg-purple-800 text-white rounded-lg flex justify-center items-center ${loading ? "opacity-50 cursor-not-allowed" : "hover:opacity-60 cursor-pointer"
                  } focus:outline-none`}
              >
                {loading ? (
                  <FaSpinner className="animate-spin mr-2" />
                ) : (
                  "Iniciar sesión"
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Login;
